import {Dialog} from '@headlessui/react'
import styles from '@/../sass/components/Modal.module.scss'

export default function Modal(props) {
    const disableCloseButton = props.disableCloseButton ?? false;
    const dialogSpecialStyle = props.style ?? {};

    return (
        <Dialog
            as="div"
            style={dialogSpecialStyle}
            className={props.dialogClassName ? styles.overlay + " " + props.dialogClassName : styles.overlay}
            id={props.id}
            dataTestid={props.dataTestid}
            initialFocus={props.initialFocusRef}
            open={props.isOpen}
            onClose={disableCloseButton || props.disableClickAway? () => {} : () => props.setIsOpen(false)}
        >
            <div className={props.modalWrapClassName ? styles.wrap + " " + props.modalWrapClassName : styles.wrap}>
                <div className={props.modalClassName ? styles.modal + " " + props.modalClassName : styles.modal}>
                    <Dialog.Panel>
                        <Dialog.Title className={styles.title}>
                            {props.title}
                            {!disableCloseButton &&
                                (<button className="btn btn-toolbar" onClick={() => props.setIsOpen(false)}><i
                                    className="fa fa-times"></i></button>)
                            }

                        </Dialog.Title>
                        <div className={styles.content}>
                            {props.children}
                        </div>
                    </Dialog.Panel>
                </div>
            </div>
        </Dialog>
    )
}
